// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GlobalOutlinedSvg from "@fishx/icons-svg/es/asn/GlobalOutlined";
import FishxIcon from '../components/FishxIcon';

var GlobalOutlined = function GlobalOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GlobalOutlinedSvg
  }));
};

GlobalOutlined.displayName = 'GlobalOutlined';
export default React.forwardRef(GlobalOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GlobalOutlined.js
// module id = 2882
// module chunks = 0